import { Link } from "react-router-dom";

const footerLinks = {
  福利分类: [
    { label: "电商优惠", href: "/category/dianshang-youhui" },
    { label: "会员权益", href: "/category/huiyuan-quanyi" },
    { label: "生活补贴", href: "/category/shenghuo-butie" },
    { label: "政府福利", href: "/category/zhengfu-fuli" },
    { label: "金融服务", href: "/category/jinrong-fuwu" },
    { label: "教育福利", href: "/category/jiaoyu-fuli" },
  ],
  热门推荐: [
    { label: "双十一优惠攻略", href: "/article/article-1" },
    { label: "视频会员免费领取", href: "/article/article-2" },
    { label: "租房补贴政策", href: "/article/article-3" },
    { label: "个税扣除攻略", href: "/article/article-4" },
    { label: "信用卡权益对比", href: "/article/article-5" },
    { label: "免费在线课程", href: "/article/article-6" },
  ],
  关于我们: [
    { label: "品牌介绍", href: "/about" },
    { label: "联系方式", href: "/about" },
    { label: "用户口碑", href: "/about" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gift-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-semibold text-foreground-950 font-heading">
                福利导航
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              一站式福利资源聚合平台，为您汇聚全网优质福利资源，省时省钱，轻松享受各类专属权益。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">
                {title}
              </h4>
              <ul className="flex flex-col gap-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 福利导航 jobbang.cn - 本站内容仅供信息参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">
              用户协议
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}